import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ActivityLog {
  id: number;
  createdAt: string;
  visitorId?: number;
  visitId?: number;
  roomId?: number;
  actionType: string;
  status: string;
  message?: string;
  details?: string;
  cardId?: string;
  phone?: string;
  email?: string;
  errorCode?: string;
  errorMessage?: string;
  performedBy?: string;
  ipAddress?: string;
  surcharge?: boolean;
  surchargeHours?: number;
  gratis?: boolean;
  visitorFullName?: string; // Dodato za prikaz imena i prezimena posetioca
}

@Injectable({ providedIn: 'root' })
export class ActivityLogService {
  
    apiUrl = environment.apiUrl;
    private paginationSource = new ReplaySubject<any>(1);
    paginationSettings$ = this.paginationSource.asObservable();

  constructor(private http: HttpClient) {}

  getLogs(filter: any = {}): Observable<ActivityLog[]> {
    const body = {
      pageNumber: filter.pageNumber || 1,
      pageSize: filter.pageSize || 20,
      ...filter
    };
    return this.http.post<ActivityLog[]>(`${this.apiUrl}api/ActivityLog/search`, body, { observe: 'response' })
      .pipe(
        map(res => {
          const paginationHeader = res.headers.get('Pagination');
          if (paginationHeader) {
            this.paginationSource.next(JSON.parse(paginationHeader));
          }
          return res.body || [];
        })
      );
  }
}
